import Rating from '@mui/material/Rating';
import { CommonTooltip, Icons, TableItemActionsNew } from 'components';
const columns = (actionsList, navigate) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'شناسه کسب‌وکار',
    field: 'id',
    filtering: false,
    sorting: false,
    align: 'center',
  },
  {
    title: 'نام زیرمجموعه',
    field: 'name',
    filtering: false,
    sorting: false,
    align: 'center',
  },
  {
    title: 'نام کاربری',
    field: 'username',
    filtering: false,
    sorting: false,
    align: 'center',
  },
  {
    title: 'وضعیت',
    field: 'active',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) => (rd.active ? 'فعال' : 'غیرفعال'),
  },
  {
    title: 'نام و نام خانوادگی مالک',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) => rd.owner?.name || '-',
  },
  {
    title: 'نام و نام خانوادگی نماینده',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) => (rd.agent ? `${rd.agent?.firstName} ${rd.agent?.lastName}` : '-'),
  },
  {
    title: 'تعداد محصول ثبت شده',
    field: 'numOfProducts',
    filtering: false,
    sorting: false,
    align: 'center',
  },
  {
    title: 'امتیاز',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) => (
      <CommonTooltip title={`${rd.rate?.rateCount} رای`}>
        <div>
          <Rating style={{ direction: 'ltr' }} icon={<span style={{marginLeft:'5PX'}}><Icons icon='startEmpty' color='#bfbfbf' size='20' /></span>} name="read-only" value={rd.rate?.rate} readOnly />
        </div>
      </CommonTooltip>
    ),
  },

  ...((actionsList['delegationSubbusinessPage'] ||
    actionsList['detailSubbusinessPage'] || actionsList['updateSubbusinessPage']) ? [{
      title: 'عملیات',
      field: 'operationSmall',
      filtering: false,
      sorting: false,
      align: 'right',
      cellStyle: {
        width: '1%',
      },
      headerStyle: {
        width: '1%',
      },
      render: (rowData) => (
        <TableItemActionsNew
          iconButton
          startIcon={<Icons icon="MoreHorizontal" color="#667585"  size="17" />}
          title=""
          otherMenus={[
            {
              title: 'تفویض وجه',
              isShow: !!actionsList['delegationSubbusinessPage'],
              onClick: () => navigate(`/DelegationToUser?username=${rowData.username}&Type=SubBusiness`, { state: rowData }),
            },
            {
              title: 'جزییات',
              isShow: !!actionsList['detailSubbusinessPage'],
              onClick: () => navigate('/SubBusiness/Detail', { state: { subset: rowData } }),
            },
            {
              title: 'ویرایش',
              isShow: !!actionsList['updateSubbusinessPage'],
              onClick: () => navigate(`/SubBusiness/${rowData.id}`, { state: { branchInfo: rowData } }),
            },
          ]}
        />
      ),
    }] : []),
];

const generateData = (rows, query) => {
  return rows?.map?.((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    ...row,
  }));
};

export { columns, generateData };

